import { render, staticRenderFns } from "./campo-check-box-editavel.vue?vue&type=template&id=172b2298"
import script from "./campo-check-box-editavel.vue?vue&type=script&lang=js"
export * from "./campo-check-box-editavel.vue?vue&type=script&lang=js"
import style0 from "./campo-check-box-editavel.vue?vue&type=style&index=0&id=172b2298&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports